const MAX_LENGTH_PW = 6;
const SORT = "createdAt";
const DIRECTION = "desc";
const LIMIT = 25;
const SKIP = 0;

export { MAX_LENGTH_PW, SORT, DIRECTION, LIMIT, SKIP };
